import { AiButtonType, NewsType } from 'js/social/shared/types';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';
import toSnakecaseKeys from 'js/utils/toSnakecaseKeys';

export async function getSummary(
  newsId: string | number,
  newsType: NewsType,
  type: AiButtonType,
  extra: object = {},
): Promise<string> {
  const response = await fetchWithCsrf(
    routes.api_v0_community_summarize_path(
      toSnakecaseKeys({
        subdomain_param: 'api',
        newsId,
        newsType,
        type,
        ...extra,
      }),
    ),
  );
  if (!response.ok) {
    throw new Error(`Couldn't generate explanation.`);
  }

  return (await response.json()).summary;
}
